import styled from 'styled-components';

import IconSodium from 'components/icons/sodium-flag';
import { brandFont } from 'components/layout/brand-font';

export const InformationTitle = styled.h2`
  margin-left: 1rem;
  font: ${brandFont.headerThree};
  color: ${({ theme }) => theme.token('text-default')};

  ${Styles.desktopLarge`
    margin-top: 1rem;
    margin-bottom: 1.125rem;
  `}
`;

export const StyledSodiumFlag = styled(IconSodium)`
  height: 20px;
  margin-bottom: -0.2rem;
  margin-left: 0.2rem;
  fill: ${Styles.color.black};
`;

export const NutritionInformationWrapper = styled.div`
  ${Styles.desktopLarge`
    margin: 0 -1rem;
  `}
`;
